// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const CalmHealthLogo = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 82 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M63.976-26.269H17.303c-10.347 0-18.735 8.404-18.735 18.77v46.76c0 10.365 8.388 18.769 18.735 18.769h46.673c10.348 0 18.736-8.404 18.736-18.77V-7.5c0-10.365-8.388-18.769-18.736-18.769Z"
			fill="url(#CalmHealthLogo_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="CalmHealthLogo_tsx__a"
				x1={-1.432}
				y1={-26.269}
				x2={-1.432}
				y2={58.03}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#60B4E7" />
				<stop offset={1} stopColor="#6461E0" />
			</linearGradient>
		</defs>
	</svg>
);
export default CalmHealthLogo;
